import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value", "onChange"]
const _hoisted_6 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", null, [
      _withDirectives(_createElementVNode("input", {
        class: "field-input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.productName) = $event)),
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateRow && _ctx.updateRow(...args))),
        disabled: ""
      }, null, 544), [
        [_vModelText, _ctx.productName]
      ])
    ]),
    _createElementVNode("td", null, [
      _withDirectives(_createElementVNode("input", {
        class: "field-input",
        type: "number",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.amount) = $event)),
        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateRow && _ctx.updateRow(...args))),
        min: "0"
      }, null, 544), [
        [_vModelText, _ctx.amount]
      ])
    ]),
    _createElementVNode("td", null, [
      _withDirectives(_createElementVNode("select", {
        class: "field-select",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedVatCode) = $event)),
        onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onVatCodeChange && _ctx.onVatCodeChange(...args)))
      }, [
        _cache[10] || (_cache[10] = _createElementVNode("option", {
          value: "",
          disabled: ""
        }, "Select a VAT code", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vatCodes, (vatCode) => {
          return (_openBlock(), _createElementBlock("option", {
            key: vatCode.id,
            value: vatCode.id
          }, _toDisplayString(vatCode.name), 9, _hoisted_1))
        }), 128))
      ], 544), [
        [_vModelSelect, _ctx.selectedVatCode]
      ])
    ]),
    _createElementVNode("td", null, [
      _withDirectives(_createElementVNode("select", {
        class: "field-select",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedVatPercent) = $event)),
        onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.updateRow && _ctx.updateRow(...args))),
        disabled: !_ctx.availablePercentages.length
      }, [
        _cache[11] || (_cache[11] = _createElementVNode("option", {
          value: "",
          disabled: ""
        }, "Select percentage", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePercentages, (percentage) => {
          return (_openBlock(), _createElementBlock("option", {
            key: percentage,
            value: percentage
          }, _toDisplayString(percentage) + "% ", 9, _hoisted_3))
        }), 128))
      ], 40, _hoisted_2), [
        [_vModelSelect, _ctx.selectedVatPercent]
      ])
    ]),
    _createElementVNode("td", null, [
      _withDirectives(_createElementVNode("select", {
        class: "field-select",
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedAccount) = $event)),
        onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.updateRow && _ctx.updateRow(...args)))
      }, [
        _cache[12] || (_cache[12] = _createElementVNode("option", {
          value: "",
          disabled: ""
        }, "Select an account", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (account) => {
          return (_openBlock(), _createElementBlock("option", {
            key: account.id,
            value: account.id
          }, _toDisplayString(account.accountNumber + ' ' + account.accountName), 9, _hoisted_4))
        }), 128))
      ], 544), [
        [_vModelSelect, _ctx.selectedAccount]
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dimensions, (dimension, index) => {
      return (_openBlock(), _createElementBlock("td", {
        key: dimension.id
      }, [
        _createElementVNode("select", {
          class: "field-select",
          value: _ctx.selectedDimensions[index].id,
          onChange: (e) => _ctx.onDimensionChange(index, dimension.options?.find(o => o.id === (e.target as HTMLSelectElement).value) || {id: '', name: ''})
        }, [
          _cache[13] || (_cache[13] = _createElementVNode("option", {
            value: "",
            disabled: ""
          }, "-", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dimension.options, (dimensionOption) => {
            return (_openBlock(), _createElementBlock("option", {
              key: dimensionOption.id,
              value: dimensionOption.id
            }, _toDisplayString(dimensionOption.name), 9, _hoisted_6))
          }), 128))
        ], 40, _hoisted_5)
      ]))
    }), 128))
  ]))
}